ModalContactLocationController.$inject = ['contact']

export default function ModalContactLocationController(contact) {
  var vm = this

  vm.contact = contact
}